import { reactive } from 'vue'

export const store = reactive({
  LOADING: false,
  TYPE_LOADING: 'SSkeletonTable',
  MICROINSTALLERS: {},
})
